import { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Award, Download, ExternalLink } from "lucide-react";

export default function Certificates() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/certificates/me").then(r => setItems(r.data.items)); }, []);

    const downloadCert = async (id, certNo) => {
        const resp = await api.get(`/certificates/${id}/pdf`, { responseType: "blob" });
        const url = URL.createObjectURL(resp.data);
        const a = document.createElement("a");
        a.href = url; a.download = `certificate-${certNo}.pdf`; a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="space-y-6" data-testid="certificates-page">
            <div>
                <div className="text-xs uppercase tracking-widest font-bold text-muted-foreground">Earned</div>
                <h1 className="font-display text-3xl lg:text-4xl mt-1">Certificates</h1>
            </div>
            {items.length === 0 ? (
                <div className="mx-card p-12 text-center">
                    <Award className="h-12 w-12 mx-auto text-[#FFA81B]" />
                    <div className="mt-4 font-bold text-lg">No certificates yet</div>
                    <div className="text-sm text-muted-foreground mt-1">Complete all lessons, assignments and the final quiz of a course to earn a certificate.</div>
                </div>
            ) : (
                <div className="grid gap-5 md:grid-cols-2">
                    {items.map(c => (
                        <Card key={c.id} className="mx-card overflow-hidden" data-testid={`cert-${c.id}`}>
                            <div className="aspect-[1.4/1] bg-gradient-to-br from-[#F0EFFF] to-white dark:from-[#1C1A2E] dark:to-[#130E0E] p-6 lg:p-8 relative flex flex-col border-b border-border">
                                <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">MX Academy</div>
                                <div className="font-display text-2xl lg:text-3xl mt-2">Certificate of Completion</div>
                                <div className="text-xs text-muted-foreground mt-3">MX Academy certifies that</div>
                                <div className="font-display text-xl lg:text-2xl mt-1 mx-brand-text">{c.student_name}</div>
                                <div className="text-xs text-muted-foreground mt-3">has successfully completed</div>
                                <div className="font-bold text-base mt-1">{c.course_title}</div>
                                <div className="mt-auto flex items-end justify-between">
                                    <div>
                                        <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Cert ID</div>
                                        <div className="font-mono text-xs mt-0.5">{c.cert_number}</div>
                                    </div>
                                    <div className="h-12 w-12 rounded-full bg-amber-gradient flex items-center justify-center text-white font-display text-xs shadow-mx-md">MX</div>
                                </div>
                            </div>
                            <CardContent className="p-4 flex gap-2">
                                <Button onClick={() => downloadCert(c.id, c.cert_number)} className="mx-btn-primary flex-1" data-testid={`download-cert-${c.id}`}><Download className="h-4 w-4 mr-2" /> Download PDF</Button>
                                <Button variant="outline" onClick={() => window.open(`/verify/${c.cert_number}`, "_blank")} className="rounded-xl" data-testid={`verify-cert-${c.id}`}><ExternalLink className="h-4 w-4" /></Button>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            )}
        </div>
    );
}
